<template>
  <vx-card>
    <template slot="no-body">
      <div class="flex pl-2 loading-fix items-center justify-between p-4">
        <div class="flex">
          <div class="flex items-center" style="gap: 10px">
            <h4>Geofence Name :</h4>
            <input
              style="flex: 1"
              class="vs-input vs-input--input normal"
              type="text"
              v-model="name" />
          </div>
          <div class="flex pl-2 items-center" style="gap: 10px">
            <h4>Geofence Type :</h4>
            <vs-select
              class="selectExample"
              v-model="geofence_category_detail.geofence_type_id">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in selected_geofence_types" />
            </vs-select>
          </div>
        </div>

        <div
          class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default mb-2 vs-con-loading__container">
          <vs-switch v-model="is_red_zone" class="vs-switch-danger"></vs-switch>
          <span class="con-slot-label">RED ZONE</span>
        </div>

        <div class="flex justify-between" style="gap: 10px">
          <vs-button
            @click="deleteSelectedShape"
            type="border"
            class="shadow float-right mr-2 normal"
            color="danger"
            gradient-color-secondary="#CE9FFC"
            >Clear Map
          </vs-button>
          <vs-button
            @click="submit"
            color="danger"
            gradient-color-secondary="#f89595"
            >Update
          </vs-button>
        </div>
      </div>
      <vs-divider style="margin-bottom: 0" />
      <div class="heights">
        <div class="search">
          <div class="center content-inputs">
            <vs-input
              id="search_location"
              v-model="value"
              placeholder="Search Location.."
              icon="search"
              icon-no-border>
            </vs-input>
          </div>
          <!-- <input
            type="text"
            placeholder="Search Location.."
            id="search_location" />
          <input
            type="number"
            v-model="search_lat"
            placeholder="Latitude"
            style="width: 100px; margin-right: 5px" />
          <input
            type="number"
            v-model="search_lng"
            placeholder="Longitude"
            style="width: 100px; margin-right: 5px" /> -->
          <button
            @click="recenter()"
            :disabled="!search_lat || !search_lng"
            style="padding: 2px 4px">
            Re-Center
          </button>
        </div>
        <!-- <div id="color-palette">
          <swatches v-model="color" colors="text-advanced" popover-to="left" />
        </div> -->
        <div
          class="py-4 px-8"
          :class="{'h-full':dropdown_geofence_category_detail}"
          style="
            position: absolute;
            z-index: 2;
            background-color: white;
            border-radius: 0% 0% 2% 0%;
          ">
          <div class="flex justify-between" style="width: 300px;" >
            <p style="font-weight: bold; color: red">Geofence Detail</p>
            <feather-icon
              v-if="dropdown_geofence_category_detail"
              icon="ChevronDownIcon"
              @click="clickDetailGeo"
              class="danger" />
            <feather-icon
              v-else="dropdown_geofence_category_detail"
              icon="ChevronUpIcon"
              @click="clickDetailGeo"
              class="danger" />
          </div>
          <div v-if="dropdown_geofence_category_detail" >
            <div class="mt-4">
              <p>Geofence Name</p>
              <h1>{{ name }}</h1>
            </div>
            <div class="mt-4">
              <p>Geofence Type</p>
              <h1>{{ geofence_category_detail.geofence_type }}</h1>
            </div>
            <div class="mt-4">
              <vs-checkbox
                v-model="geofence_category_detail.alert_in"
                class="vs-checkbox-danger mt-4"
                disabled="true"
                >Alert In Zone</vs-checkbox
              >
              <vs-checkbox
                v-model="geofence_category_detail.alert_out"
                class="vs-checkbox-danger mt-4"
                disabled="true"
                >Alert Out Zone</vs-checkbox
              >
              <vs-checkbox
                v-model="geofence_category_detail.geofence_dc"
                class="vs-checkbox-danger mt-4"
                disabled="true"
                >Geofence DC</vs-checkbox
              >
            </div>
            <div class="mt-4">
              <div class="mt-4">
                <label for="">Overspeed Threshold</label>
                <div class="flex items-center" style="gap: 10px">
                  <vs-input
                    disabled="true"
                    v-model="geofence_category_detail.overspeed" />km/h
                </div>
              </div>
              <div class="mt-4">
                <label for="">Overstay On Threshold</label>
                <div class="flex items-center" style="gap: 10px">
                  <vs-input
                    disabled="true"
                    v-model="geofence_category_detail.overstay_on" />minutes
                </div>
              </div>
              <div class="mt-4">
                <label for="">Overstay Off Threshold</label>
                <div class="flex items-center" style="gap: 10px">
                  <vs-input
                    disabled="true"
                    v-model="geofence_category_detail.overstay_off" />minutes
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <span></span>
        <GmapMap
          ref="mapRef"
          :center="center"
          :zoom="11"
          style="width: 100%; height: 100%"
          :options="{
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false,
          }">
          <GmapPolygon> </GmapPolygon>
        </GmapMap>
      </div>
    </template>
  </vx-card>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import * as REPO from '../../../repository/index'
import Swatches from 'vue-swatches'

import 'vue-swatches/dist/vue-swatches.min.css'

export default {
  components: { Swatches },
  props: {},
  computed: {
    google: gmapApi,
  },
  watch: {
    geofence_category_detail: {
      handler(newVal, oldVal) {
        newVal.geofence_type_id = newVal.geofence_type_id
        newVal.geofence_type = this.data_geofence_types.find(
          (x) => x.id == newVal.geofence_type_id
        ).geofence_type
        newVal.alert_in = this.data_geofence_types.find(
          (x) => x.id == newVal.geofence_type_id
        ).alert_in
        newVal.alert_out = this.data_geofence_types.find(
          (x) => x.id == newVal.geofence_type_id
        ).alert_out
        newVal.overspeed = this.data_geofence_types.find(
          (x) => x.id == newVal.geofence_type_id
        ).overspeed
        newVal.overstay_on = this.data_geofence_types.find(
          (x) => x.id == newVal.geofence_type_id
        ).overstay_on_dry
        newVal.overstay_off = this.data_geofence_types.find(
          (x) => x.id == newVal.geofence_type_id
        ).overstay_off_dry
        newVal.geofence_dc = true

      },
      deep: true,
    },
    name(val) {
      this.name = val.toUpperCase()
    },
    color(val) {
      // ("color change",val);
      this.selectColor(val)
      this.setSelectedShapeColor(val)
    },
  },
  created() {
    this.getGeofenceCategory()
    this.getPolygon()

  },
  mounted() {
    var self = this
    this.$refs.mapRef.$mapPromise.then((map) => {
      var input = document.getElementById('search_location')

      var autocomplete = new google.maps.places.Autocomplete(input)
      autocomplete.setComponentRestrictions({ country: ['id'] })
      autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace()
        let lat = place.geometry.location.lat()
        let lng = place.geometry.location.lng()
        self.search_lat = lat
        self.search_lng = lng

        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport)
        } else {
          map.setCenter(place.geometry.location)
          map.setZoom(17) // Why 17? Because it looks good.
        }
      })
      this.map = map
      google.maps.Polygon.prototype.getBounds = function () {
        var bounds = new google.maps.LatLngBounds()
        var paths = this.getPaths()
        var path
        for (var i = 0; i < paths.getLength(); i++) {
          path = paths.getAt(i)
          for (var ii = 0; ii < path.getLength(); ii++) {
            bounds.extend(path.getAt(ii))
          }
        }
        return bounds
      }

      this.getPolygon()
    })
  },
  data() {
    return {
      overlays: [],
      color: '#EB2714',
      data_coordinate: [],
      centerCircle: null,
      is_red_zone: false,
      drawingManager: '',
      selectedShape: '',
      type_array: [
        {
          text: 'POI',
          value: 'POI',
        },
        {
          text: 'AREA',
          value: 'AREA',
        },
      ],
      name: '',
      id: '',
      type: '',
      radius: '',

      search_lat: '',
      search_lng: '',
      selectedColor: '',
      colorButtons: {},
      map: null,
      colors: ['#1E90FF', '#FF1493', '#32CD32', '#FF8C00', '#4B0082'],
      center: { lat: -6.1498619, lng: 106.882887 },
      geofence_detail: null,
      geofence_category_detail: {
        geofence_name: '',
        geofence_type: '',
        geofence_type_id: '',
        alert_in: null,
        alert_out: null,
        geofence_dc: null,
        overspeed: null,
        overstay_on: null,
        overstay_off: null,
      },
      dropdown_geofence_category_detail: false,
      selected_geofence_types: [],
      data_geofence_types: [],
    }
  },
  methods: {
    recenter() {
      if (this.search_lat && this.search_lat) {
        let lokk = new google.maps.LatLng(this.search_lat, this.search_lng)
        this.map.setCenter(lokk)
        this.map.setZoom(15)
      }
    },
    onInput: function (hue) {
      this.color.hue = hue
    },
    clearFields() {
      this.name = ''
    },
    loadingStart() {
      this.$vs.loading({
        container: `.loading-fix`,
        scale: 0.45,
      })
    },
    loadingStop() {
      this.$vs.loading.close(`.loading-fix > .con-vs-loading`)
    },
    getPolygon() {
      this.id = this.$route.params.id
      var self = this
      REPO.getOneGeofence(this.id).then((res_geo) => {
        this.name = res_geo.data.data.geofence_name
        this.type = res_geo.data.data.type
        this.is_red_zone = res_geo.data.data.is_red_zone == 1
        
        if(res_geo.data.data.geofence_category_name &&  res_geo.data.data.geofence_category_id){
        this.geofence_category_detail.geofence_type =
          res_geo.data.data.geofence_category_name
        this.geofence_category_detail.geofence_type_id =
          res_geo.data.data.geofence_category_id
        this.geofence_category_detail.alert_in = this.data_geofence_types.find(
          (x) => x.id == this.geofence_category_detail.geofence_type_id
        ).alert_in
        this.geofence_category_detail.alert_out = this.data_geofence_types.find(
          (x) => x.id == this.geofence_category_detail.geofence_type_id
        ).alert_out
        this.geofence_category_detail.geofence_dc = 1
        this.geofence_category_detail.overspeed = this.data_geofence_types.find(
          (x) => x.id == this.geofence_category_detail.geofence_type_id
        ).overspeed
        this.geofence_category_detail.overstay_on = this.data_geofence_types.find(
          (x) => x.id == this.geofence_category_detail.geofence_type_id
        ).overstay_on_dry
        this.geofence_category_detail.overstay_off = this.data_geofence_types.find(
          (x) => x.id == this.geofence_category_detail.geofence_type_id
        ).overstay_off_dry
        this.geofence_category_detail.geofence_dc = true
      }

        if (this.type == 'CIRCLE') {
          this.data_coordinate = res_geo.data.data.geofence_detail.coordinates
        } else {
          this.data_coordinate =
            res_geo.data.data.geofence_detail.coordinates[0]
        }

        this.$refs.mapRef.$mapPromise.then((map) => {
          var polyOptions = {
            strokeWeight: 0,
            fillOpacity: 0.45,
            editable: true,
          }
          // Creates a drawing manager attached to the map that allows the user to draw
          // markers, lines, and shapes.
          this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControlOptions: {
              position: google.maps.ControlPosition.BOTTOM,
              drawingModes: [
                google.maps.drawing.OverlayType.POLYGON,
                google.maps.drawing.OverlayType.CIRCLE,
              ],
            },
            markerOptions: {
              draggable: true,
            },
            polylineOptions: {
              editable: false,
            },
            rectangleOptions: polyOptions,
            circleOptions: polyOptions,
            polygonOptions: polyOptions,
            map: map,
          })
          if (this.type.toUpperCase() == 'CIRCLE') {
            let lat = this.data_coordinate[1]
            let lng = this.data_coordinate[0]
            let center = {
              lat: lat,
              lng: lng,
            }

            let color = '#FF0000'
            if (res_geo.data.data.colour) {
              color = res_geo.data.data.colour
              this.color = color
            }
            var circle = new google.maps.Circle({
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.35,
              map: map,
              center: center,
              radius: res_geo.data.data.radius,
            })
            self.centerCircle = {
              latitude: center.lat,
              longitude: center.lng,
            }
            self.radius = res_geo.data.data.radius
            google.maps.event.addListener(
              circle,
              'center_changed',
              function (e) {
                let radius = circle.getRadius()
                let center = circle.getCenter()

                let lng = center.lng()
                let lat = center.lat()
                self.centerCircle = {
                  latitude: lat,
                  longitude: lng,
                }
                self.radius = radius
              }
            )
            google.maps.event.addListener(
              circle,
              'radius_changed',
              function (e) {
                let radius = circle.getRadius()
                let center = circle.getCenter()

                let lng = center.lng()
                let lat = center.lat()
                self.center = {
                  latitude: lat,
                  longitude: lng,
                }
                self.radius = radius
              }
            )

            map.fitBounds(circle.getBounds())
            self.setSelection(circle)
          }
          if (this.type.toUpperCase() == 'RECTANGLE') {
            let center = {
              lat: this.data_coordinate[1],
              lng: this.data_coordinate[0],
            }

            let color = '#FF0000'
            if (res_geo.data.data.colour) {
              color = res_geo.data.data.colour
              this.color = color
            }
            var rectangle = new google.maps.Rectangle({
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.35,
              map: map,
              bounds: {
                north: this.data_coordinate[0]['0'],
                south: this.data_coordinate[1]['0'],
                east: this.data_coordinate[0]['1'],
                west: this.data_coordinate[2]['1'],
              },
            })

            map.fitBounds(rectangle.getBounds())
            self.setSelection(rectangle)
            google.maps.event.addListener(
              rectangle,
              'bounds_changed',
              function (e) {
                let bound = rectangle.getBounds()
                let coor = bound.toJSON()
                self.data_coordinate = [
                  {
                    latitude: coor['north'],
                    longitude: coor['east'],
                  },
                  {
                    latitude: coor['south'],
                    longitude: coor['east'],
                  },
                  {
                    latitude: coor['south'],
                    longitude: coor['west'],
                  },
                  {
                    latitude: coor['north'],
                    longitude: coor['west'],
                  },
                ]
              }
            )
          }
          self.drawingManager.setDrawingMode(null)
          // To hide:
          self.drawingManager.setOptions({
            drawingControl: false,
          })
          if (this.type == 'POLYGON' || this.type == 'AREA') {
            var poly = []
            this.data_coordinate.forEach((x) => {
              let tmp = new google.maps.LatLng(x['1'], x['0'])
              poly.push(tmp)
            })
            let color = '#FF0000'
            if (res_geo.data.data.colour) {
              color = res_geo.data.data.colour
              this.color = color
            }
            var polygon = new google.maps.Polygon({
              path: poly,
              draggable: false,
              editable: false,
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.35,
              map: map,
            })
            // ("center");
            self.setSelection(polygon)
            google.maps.event.addListener(polygon, 'click', function (event) {
              let polygon2 = event.overlay.getPath()
              let lokasi = polygon2.getArray()
              lokasi.forEach((x) => {
                self.data_coordinate.push({
                  latitude: x.lat(),
                  longitude: x.lng(),
                })
              })
              // (self.data_coordinate);
              self.overlays.push(event.overlay)
              self.setSelection(polygon2)
            })
            map.fitBounds(polygon.getBounds())

            self.data_coordinate = []
            let lokasi = polygon.getPath().getArray()
            lokasi.forEach((x) => {
              self.data_coordinate.push({
                latitude: x.lat(),
                longitude: x.lng(),
              })
            })
            // (self.data_coordinate);
            google.maps.event.addListener(
              polygon.getPath(),
              'insert_at',
              function (e) {
                // ("Insert");
                self.data_coordinate = []
                let lokasi = polygon.getPath().getArray()
                lokasi.forEach((x) => {
                  self.data_coordinate.push({
                    latitude: x.lat(),
                    longitude: x.lng(),
                  })
                })
                //
                // (self.data_coordinate);
              }
            )

            google.maps.event.addListener(
              polygon.getPath(),
              'remove_at',
              function (e) {
                // ("remove");
                self.data_coordinate = []
                let lokasi = polygon.getPath().getArray()
                lokasi.forEach((x) => {
                  self.data_coordinate.push({
                    latitude: x.lat(),
                    longitude: x.lng(),
                  })
                })
                // (self.data_coordinate);
              }
            )
            google.maps.event.addListener(
              polygon.getPath(),
              'set_at',
              function (e) {
                // ("set_at");
                self.data_coordinate = []
                let lokasi = polygon.getPath().getArray()
                lokasi.forEach((x) => {
                  self.data_coordinate.push({
                    latitude: x.lat(),
                    longitude: x.lng(),
                  })
                })
                // (self.data_coordinate);
              }
            )

            google.maps.event.addListener(
              this.drawingManager,
              'overlaycomplete',
              onOverlayComplete
            )
          }

          google.maps.event.addListener(
            this.drawingManager,
            'overlaycomplete',
            onOverlayComplete
          )

          function onOverlayComplete(event) {
            self.data_coordinate = []
            if (event.type == google.maps.drawing.OverlayType.CIRCLE) {
              self.type = 'CIRCLE'
              let overlay = event.overlay
              let radius = event.overlay.getRadius()
              let center = event.overlay.getCenter()

              let lng = center.lng()
              let lat = center.lat()

              self.centerCircle = {
                latitude: lat,
                longitude: lng,
              }
              self.radius = radius
              google.maps.event.addListener(
                overlay,
                'center_changed',
                function (e) {
                  let radius = event.overlay.getRadius()
                  let center = event.overlay.getCenter()

                  let lng = center.lng()
                  let lat = center.lat()
                  self.centerCircle = {
                    latitude: lat,
                    longitude: lng,
                  }
                  self.radius = radius
                }
              )
              google.maps.event.addListener(
                overlay,
                'radius_changed',
                function (e) {
                  let radius = event.overlay.getRadius()
                  let center = event.overlay.getCenter()

                  let lng = center.lng()
                  let lat = center.lat()
                  self.center = {
                    latitude: lat,
                    longitude: lng,
                  }
                  self.radius = radius
                }
              )
              self.drawingManager.setDrawingMode(null)
              // To hide:
              self.drawingManager.setOptions({
                drawingControl: false,
              })
              var newShape = event.overlay
              self.setSelection(newShape)
              self.overlays.push(event.overlay)
            }
            if (event.type == google.maps.drawing.OverlayType.RECTANGLE) {
              self.type = 'RECTANGLE'
              self.centerCircle = null
              let bound = event.overlay.getBounds()
              let coor = bound.toJSON()
              let overlay = event.overlay
              self.data_coordinate = [
                {
                  latitude: coor['north'],
                  longitude: coor['east'],
                },
                {
                  latitude: coor['south'],
                  longitude: coor['east'],
                },
                {
                  latitude: coor['south'],
                  longitude: coor['west'],
                },
                {
                  latitude: coor['north'],
                  longitude: coor['west'],
                },
              ]
              // south: -6.139834738483963
              // west: 106.74590122119137
              // north: -6.046978562725505
              // east: 106.91069614306637

              google.maps.event.addListener(
                overlay,
                'bounds_changed',
                function (e) {
                  let bound = event.overlay.getBounds()
                  let coor = bound.toJSON()
                  self.data_coordinate = [
                    {
                      latitude: coor['north'],
                      longitude: coor['east'],
                    },
                    {
                      latitude: coor['south'],
                      longitude: coor['east'],
                    },
                    {
                      latitude: coor['south'],
                      longitude: coor['west'],
                    },
                    {
                      latitude: coor['north'],
                      longitude: coor['west'],
                    },
                  ]
                }
              )
              self.drawingManager.setDrawingMode(null)
              // To hide:
              self.drawingManager.setOptions({
                drawingControl: false,
              })
              var newShape = event.overlay
              self.setSelection(newShape)
              self.overlays.push(event.overlay)
            }
            if (event.type == google.maps.drawing.OverlayType.POLYGON) {
              self.centerCircle = null
              self.type = 'POLYGON'
              let polygon = event.overlay.getPath()
              let lokasi = polygon.getArray()
              lokasi.forEach((x) => {
                self.data_coordinate.push({
                  latitude: x.lat(),
                  longitude: x.lng(),
                })
              })
              //
              self.overlays.push(event.overlay)
              google.maps.event.addListener(polygon, 'insert_at', function (e) {
                self.data_coordinate = []
                let lokasi = polygon.getArray()
                lokasi.forEach((x) => {
                  self.data_coordinate.push({
                    latitude: x.lat(),
                    longitude: x.lng(),
                  })
                })
                //
                //
                //
                //
                //
                //
              })

              google.maps.event.addListener(polygon, 'remove_at', function (e) {
                self.data_coordinate = []
                let lokasi = polygon.getArray()
                lokasi.forEach((x) => {
                  self.data_coordinate.push({
                    latitude: x.lat(),
                    longitude: x.lng(),
                  })
                })
                //
              })

              google.maps.event.addListener(polygon, 'set_at', function (e) {
                self.data_coordinate = []
                let lokasi = polygon.getArray()
                lokasi.forEach((x) => {
                  self.data_coordinate.push({
                    latitude: x.lat(),
                    longitude: x.lng(),
                  })
                })
                //
              })
            }
          }
          // Clear the current selection when the drawing mode is changed, or when the
          // map is clicked.
          google.maps.event.addListener(
            this.drawingManager,
            'drawingmode_changed',
            () => {
              //
              //   'drawingmode_changed',
              //   self.drawingManager.getDrawingMode()
              // )
              // self.type = self.drawingManager.getDrawingMode()
              self.clearSelection
            }
          )
          google.maps.event.addListener(map, 'click', self.clearSelection)
          self.selectColor(this.color)
        })
        console.log(res_geo.data.data)
        // REPO.getGeofenceDetail(this.id).then(res => {
        //     if(res.data.data.length>0){
        //     }else{
        //         alert("Geofence has no Coordinate");
        //         this.$router.push('/master-data/geofence')
        //     }
        // });
      })
    },
    submit() {
      var self = this
      // (this.name);
      // (this.data_coordinate);
      let is_red_zone = 0
      if (this.is_red_zone) {
        is_red_zone = 1
      } else {
        is_red_zone = 0
      }

      if (this.type == 'POLYGON' || this.type == 'RECTANGLE') {
        if (this.data_coordinate.length === 0 || this.name === '') {
          this.$toast.error(
            'Please Fill the name and draw a polygon on the map'
          )
          return
        }
      }
      if (this.type == 'CIRCLE') {
        if (this.centerCircle == null) {
          this.$toast.error('Please Fill the name and draw the circle')
          return
        }
      }
      // let data_ = {
      //     type    :"AREA",
      //     colour  : this.color,
      //     is_red_zone,
      //     geofence_detail : self.data_coordinate,
      //     geofence_name: this.name,
      //     updated_by : this.$dataLocal.UserData().name
      // };
      let data_
      if (this.type == 'POLYGON') {
        data_ = {
          type: 'POLYGON',
          colour: this.color,
          is_red_zone: is_red_zone,
          geofence_detail: self.data_coordinate,
          geofence_name: this.name,
          updated_by: this.$dataLocal.UserData().name,
        }
      }
      if (this.type == 'RECTANGLE') {
        data_ = {
          type: 'RECTANGLE',
          colour: this.color,
          is_red_zone: is_red_zone,
          geofence_detail: self.data_coordinate,
          geofence_name: this.name,
          updated_by: this.$dataLocal.UserData().name,
        }
      }
      if (this.type == 'CIRCLE') {
        let arr = []
        arr.push(this.centerCircle)
        data_ = {
          type: 'CIRCLE',
          colour: this.color,
          radius: this.radius,
          is_red_zone: is_red_zone,
          geofence_detail: arr,
          geofence_name: this.name,
          updated_by: this.$dataLocal.UserData().name,
        }
      }
      // if (this.data_coordinate.length === 0 || this.name === '') {
      //   this.$toast.error('Please Fill the name and draw a polygon on the map')
      //   return
      // }
      this.loadingStart()

      data_.geofence_category_detail = this.geofence_category_detail
      // )
      REPO.updateGeofence(data_, this.id)
        .then((res) => {
          this.loadingStop()
          if (res.data.status == 'true') {
            this.clearFields()
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfully Submitted')
            setTimeout(() => {
              this.$router.push('/master-data/geofence')
            })
          } else {
            this.$toast.error(res.data.error_msg)
          }
          // let data_detail = {
          //     geofence_id     : res.data.data.id,
          //     created_by      : self.$dataLocal.UserData().name,
          //     data_geofence   : self.data_coordinate
          // };
          // REPO.updateGeofenceDetail(data_detail, this.id).then(res2 =>{
          //     this.loadingStop();
          //
          // }).catch(err2 => {
          //     self.loadingBtnStop();
          //
          //     self.$vs.notify({
          //         time: 2500,
          //         title: 'Error',
          //         text: err2.message,
          //         iconPack: 'feather',
          //         icon: 'icon-alert-circle',
          //         color: 'danger'
          //     });
          // });
        })
        .catch((err) => {
          this.loadingStop()
          this.$toast.error(err.message)
        })
    },
    getGeofenceCategory() {
      // this.geofence_types = []
      REPO.getListGeofenceCategory()
        .then((res) => {
          const data = res.data.data.data
          data.forEach((x) => {
            this.selected_geofence_types.push({
              text: x.geofence_type,
              value: x.id,
            })
          })
          this.data_geofence_types = data
        })
        .catch((err) => {
          alert(err)
        })
    },
    clearSelection() {
      if (this.selectedShape) {
        this.selectedShape.setEditable(false)
        this.selectedShape = null
      }
    },
    setSelection(shape) {
      this.clearSelection()
      this.selectedShape = shape
      shape.setEditable(true)
      this.selectColor(shape.get('fillColor') || shape.get('strokeColor'))
    },
    deleteSelectedShape() {
      this.data_coordinate = []
      if (this.selectedShape) {
        this.selectedShape.setMap(null)
        // To show:
        this.drawingManager.setOptions({
          drawingControl: true,
          drawingMode: null,

        })
      }
    },
    setSelectedShapeColor(color) {
      if (this.selectedShape) {
        if (
          this.selectedShape.type == google.maps.drawing.OverlayType.POLYLINE
        ) {
          this.selectedShape.set('strokeColor', color)
        } else {
          this.selectedShape.set('strokeColor', color)
          this.selectedShape.set('fillColor', color)
        }
      }
    },
    selectColor(color) {
      this.selectedColor = color
      var polygonOptions = this.drawingManager.get('polygonOptions')
      polygonOptions.fillColor = color
      this.drawingManager.set('polygonOptions', polygonOptions)
    },
    bersihkanMap() {
      var lastOverlay = this.overlays.pop()
      if (lastOverlay) lastOverlay.setMap(null)
    },
    clickDetailGeo() {
      this.dropdown_geofence_category_detail =
        !this.dropdown_geofence_category_detail
    },
  },
}
</script>
<style lang="scss">
.heights {
  height: calc(100vh - 15.1rem);
}
</style>
<style scoped>
#search_location {
  display: block;
  width: 100%;
  padding: 2px;
  margin-bottom: 5px;
}

.search {
  position: absolute;
  z-index: 2;
  right: 8px;
  top: 78px;
  padding: 5px;
  background: #8c8c8c8c;
  box-shadow: 0 2px 2px;
}

#color-palette {
  position: absolute;
  z-index: 2;
  right: 11px;
  top: 145px;
}
</style>
